import type { MedicationDetection } from '@heidi/growth/contracts';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

/** Per-session detections — no cross-session PHI bleed. */
export const medicationDetectionsAtomFamily = atomFamily((sessionId: string) => {
  void sessionId;
  return atom<MedicationDetection[]>([]);
});
